import { createContext, useContext, useState } from "react";

const AuthContext = createContext();
export default function LoginContextProvider({ children }) {
  const [authenticated, setAuthenticated] = useState(() => {
    const storedAuth = JSON.parse(localStorage.getItem("loginStatus"));
    return storedAuth || false;
  });
  const [userId, setUserID] = useState(() => {
    const storedAuth = JSON.parse(localStorage.getItem("userID"));
    return storedAuth || null;
  });
  const [access, setAccess] = useState(() => {
    const storedAuth = JSON.parse(localStorage.getItem("access"));
    return storedAuth || [];
  });

  const [userImage, setUserImage] = useState(() => {
    const storedAuth = JSON.parse(localStorage.getItem("userImage"));
    return storedAuth || null;
  });

  const [userDetails, setUserDetails] = useState(() => {
    const storedAuth = JSON.parse(localStorage.getItem("userDetails"));
    return storedAuth || null;
  });

  const [routesData, setRoutesData] = useState([]);

  const logout = () => {
    setAuthenticated(false);

    localStorage.clear();
  };
  return (
    <AuthContext.Provider
      value={{
        authenticated,
        setAuthenticated,
        userId,
        setUserID,
        logout,
        access,
        setAccess,
        setRoutesData,
        routesData,
        userImage,
        setUserImage,
        userDetails,
        setUserDetails,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuthData = () => {
  return useContext(AuthContext);
};
